import { ArrowRight, BookOpen } from 'lucide-react';

const AMAZON_URL = 'https://www.amazon.com/Wealth-Any-Age-Practical-Building-ebook/dp/B0GX22ZDMC/';

export default function BookSection() {
  return (
    <div id="book" className="bg-gradient-to-b from-[#0A1628] to-[#0d1e35] py-24 px-6">
      <div className="max-w-5xl mx-auto">

        <div className="text-center mb-12">
          <span className="inline-block bg-slate-700/60 border border-slate-600/40 text-slate-300 text-xs px-3 py-1 rounded-full mb-4">From the same desk</span>
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-4">
            <BookOpen size={13} className="text-amber-400" />
            <span className="text-amber-300 text-xs font-semibold tracking-wide uppercase">The Book</span>
          </div>
          <h2 className="text-3xl font-bold text-white mb-3">Wealth At Any Age</h2>
          <p className="text-slate-400 max-w-xl mx-auto">
            The trading journal was built to put the book's decade-specific strategies into daily practice.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-center">
          {/* Book cover */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 scale-90 translate-y-4 bg-amber-500/15 rounded-2xl blur-3xl" />
              <a href={AMAZON_URL} target="_blank" rel="noopener noreferrer">
                <img
                  src="/assets/wealth-front.jpg"
                  alt="Wealth At Any Age by Sushil Sharma"
                  className="relative w-56 md:w-64 rounded-2xl shadow-2xl shadow-black/60 hover:scale-[1.02] transition-transform duration-300"
                />
              </a>
              <div className="absolute -bottom-3 -right-3 bg-amber-500 text-white text-xs font-bold px-3 py-1.5 rounded-xl shadow-lg shadow-amber-500/30">
                506 Pages
              </div>
            </div>
          </div>

          {/* Copy */}
          <div>
            <div className="bg-slate-800/30 border border-slate-700/40 rounded-2xl p-6 mb-6">
              <blockquote className="text-lg text-slate-200 italic leading-relaxed mb-3">
                "I'm tired of financial advice written by people who've never worried about money. This book is for people with jobs who want more."
              </blockquote>
              <p className="text-amber-400 font-semibold text-sm">— Sushil Sharma, Author</p>
            </div>

            <p className="text-slate-400 leading-relaxed mb-6 text-sm">
              Organized by decade — your 20s, 30s, 40s, and 50s each have different risks, opportunities, and strategies. 50+ income streams, tax optimization, real estate plays, and trading edge — with a chapter directly on how to use the Trading Journal to implement them.
            </p>

            <div className="grid grid-cols-3 gap-3 mb-6">
              {[['506', 'Pages'], ['50+', 'Income Streams'], ['7', 'Parts']].map(([num, label]) => (
                <div key={label} className="bg-slate-800/40 border border-slate-700/40 rounded-xl p-3 text-center">
                  <div className="text-xl font-bold text-amber-400">{num}</div>
                  <div className="text-slate-500 text-xs mt-0.5">{label}</div>
                </div>
              ))}
            </div>

            <a
              href={AMAZON_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-white font-bold px-6 py-3 rounded-xl transition-all shadow-lg shadow-amber-500/20 text-sm"
            >
              <BookOpen size={16} />
              Order on Amazon
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <p className="text-slate-600 text-xs mt-2">Kindle · Paperback · Hardcover</p>
          </div>
        </div>
      </div>
    </div>
  );
}
